/* Photos are never draggable, site-wide.
   Native image drag steals the first gesture on any drag/scroll surface — you end up
   dragging a ghost of the gown photo instead of swiping the carousel, and it bites hardest
   at responsive widths where the tile is mostly image. Capture phase so it runs before any
   section's own handler; IMG only, so dragging a link (e.g. to bookmark it) still works.
   CSS `-webkit-user-drag: none` alone does NOT reliably stop it — this listener is what
   actually guarantees it, and it covers Firefox and images injected after load. */
document.addEventListener(
  'dragstart',
  function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  },
  true
);

$(function() {
$(window).scroll(function () {
   if ($(this).scrollTop() > 900) {
      $('.header-wrapper ').addClass('header-change')
   } 
   if ($(this).scrollTop() < 900) {
      $('.header-wrapper ').removeClass('header-change')
   } 
});
});
